<script lang="ts">
  import rightMotionTail from '$lib/assets/branding/right-motion-tail.mp4'
  import leftMotionTail from '$lib/assets/branding/left-motion-tail.mp4'
  import enterMotionTail from '$lib/assets/branding/enter-motion-tail.mp4'

  import { images } from './RoadmapImages.ts'
  import RoadmapCard from './RoadmapCard.svelte'
  import type { Attachment } from 'svelte/attachments'
  import { deferVideo } from '$lib/attachments/deferVideo'

  function handleContextMenu(event: Event): void {
    event.preventDefault()
  }

  const VIDEO_OFFSET = 1
  function startVideoAt(index: number): Attachment<HTMLVideoElement> {
    return (video) => {
      const setStartTime = () => {
        video.currentTime = Math.max(0, index * VIDEO_OFFSET - (index % 2))
      }

      if (video.readyState >= 1) {
        setStartTime()
        return
      }

      video.addEventListener('loadedmetadata', setStartTime, { once: true })
      return () => video.removeEventListener('loadedmetadata', setStartTime)
    }
  }
</script>

<div class="mx-auto hidden max-w-[1700px] md:block">
  <section class="relative">
    <div class="mt-[10rem] flex flex-col items-center space-y-8 sm-desktop:space-y-20">
      <h1 class="bg-black font-cirka text-[10vw] sm-desktop:text-[160px]">Roadmap</h1>

      <ul class="relative grid w-[95vw] max-w-[875px] grid-cols-2 self-center lg:mx-auto lg-desktop:space-y-20">
        <RoadmapCard
          title="Testnet Launch"
          description="1554 CDPs opened and 1349 transactions completed."
          date="[  Jan, 2024  ]"
          iconStyles="scale-[0.25] top-[-20px]"
          containerStyles="row-start-1 col-span-2 z-[1]"
          completed
        />

        <video
          {@attach deferVideo({ media: '(min-width: 768px)' })}
          {@attach startVideoAt(0)}
          autoplay
          data-src={leftMotionTail}
          class="col-2-vid lg-desktop: absolute -right-[18vw] top-[-50px] z-0 h-[420px] w-screen scale-[0.6] object-contain lg-desktop:top-[-120px] lg-desktop:h-[460px]"
          playsinline
          loop
          muted
          defaultMuted
          disableremoteplayback
          oncontextmenu={handleContextMenu}
          preload="none"
        ></video>
        <RoadmapCard
          title="Token Sale Event"
          description="The largest token sale ever on Cardano."
          date="[  Jan, 2024  ]"
          iconStyles="scale-[0.25] top-[-25px]"
          containerStyles="row-start-2 col-start-2 z-[1] justify-self-end"
          completed
        />
        <video
          {@attach deferVideo({ media: '(min-width: 768px)' })}
          {@attach startVideoAt(1)}
          autoplay
          data-src={rightMotionTail}
          class="col-1-vid absolute -left-[17vw] top-[160px] z-0 h-[420px] w-screen scale-[0.6] object-contain lg-desktop:top-[150px] lg-desktop:h-[460px]"
          playsinline
          loop
          muted
          defaultMuted
          disableremoteplayback
          oncontextmenu={handleContextMenu}
          preload="none"
        ></video>
        <RoadmapCard
          title="Audit Completion"
          description="Bringing security assurance for Butane users."
          date="[  Aug, 2024  ]"
          icon={images.auditIcon}
          iconStyles="top-[-20px] -right-6 scale-125"
          descriptionStyles="w-[85%]"
          containerStyles="row-start-3 col-span-2 z-[1]"
          completed
        />
        <video
          {@attach deferVideo({ media: '(min-width: 768px)' })}
          {@attach startVideoAt(2)}
          autoplay
          data-src={leftMotionTail}
          class="col-2-vid absolute -right-[18vw] top-[400px] z-0 h-[420px] w-screen scale-[0.6] object-contain lg-desktop:top-[450px] lg-desktop:h-[460px]"
          playsinline
          loop
          muted
          defaultMuted
          disableremoteplayback
          oncontextmenu={handleContextMenu}
          preload="none"
        ></video>
        <RoadmapCard
          title="Contract Release"
          icon={images.openSourceIcon}
          iconStyles="-right-6 scale-150"
          description="A commitment to transparency and security."
          date="[  Nov, 2024  ]"
          descriptionStyles="w-[85%]"
          containerStyles="row-start-4 col-start-2 col-span-2 z-[1] justify-self-end"
          completed
        />
        <video
          {@attach deferVideo({ media: '(min-width: 768px)' })}
          {@attach startVideoAt(3)}
          autoplay
          data-src={rightMotionTail}
          class="col-1-vid absolute -left-[17vw] top-[600px] z-0 h-[420px] w-screen scale-[0.6] object-contain lg-desktop:top-[700px] lg-desktop:h-[480px]"
          playsinline
          loop
          muted
          defaultMuted
          disableremoteplayback
          oncontextmenu={handleContextMenu}
          preload="none"
        ></video>
        <RoadmapCard
          title="Mainnet Launch"
          description="A new era of synthetic assets begins on Cardano."
          date="[  Feb 28, 2025  ]"
          icon={images.mainnetIcon}
          iconStyles="top-[5px] -right-6 scale-125"
          descriptionStyles="w-[85%]"
          containerStyles="row-start-5 col-span-2 z-[1]"
          completed
        />
        <video
          {@attach deferVideo({ media: '(min-width: 768px)' })}
          {@attach startVideoAt(4)}
          autoplay
          data-src={leftMotionTail}
          class="col-2-vid absolute -right-[17vw] top-[850px] z-[0] h-[420px] w-screen scale-[0.6] object-contain lg-desktop:top-[1005px] lg-desktop:h-[480px]"
          playsinline
          loop
          muted
          defaultMuted
          disableremoteplayback
          oncontextmenu={handleContextMenu}
          preload="none"
        ></video>
        <RoadmapCard
          title="Decentralized Governance"
          description="Making Butane a more decentralized and open protocol."
          date="[  2025  ]"
          icon={images.governanceIcon}
          iconStyles="scale-125 top-[5px] -right-6"
          containerStyles="row-start-6 col-span-2 col-start-2 z-[1] justify-self-end md:h-[244px]"
          descriptionStyles="w-[85%]"
        />
        <video
          {@attach deferVideo({ media: '(min-width: 768px)' })}
          {@attach startVideoAt(5)}
          autoplay
          data-src={enterMotionTail}
          class="col-1-vid absolute bottom-[-160px] right-[18vw] z-0 h-[400px] w-screen scale-[0.6] object-contain lg-desktop:h-[460px]"
          playsinline
          loop
          muted
          defaultMuted
          disableremoteplayback
          oncontextmenu={handleContextMenu}
          preload="none"
        >
        </video>
      </ul>
    </div>
  </section>
</div>

<style lang="postcss">
  @media (min-width: 950) {
    video {
      width: 300px;
    }
  }
  @media (min-width: 1200px) {
    .col-2-vid {
      right: -180px;
    }
    .col-1-vid {
      left: -170px;
    }
  }
</style>
